import React from 'react';
import { Box, Card, CardContent, Grid, Skeleton } from '@mui/material';

const StatCardSkeleton: React.FC = () => (
  <Card>
    <CardContent sx={{ p: 2.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Skeleton variant="rounded" width={48} height={48} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width={80} height={18} />
          <Skeleton variant="text" width={50} height={36} />
        </Box>
      </Box>
    </CardContent>
  </Card>
);

const SectionSkeleton: React.FC<{ rows?: number }> = ({ rows = 3 }) => (
  <Card sx={{ mb: 3 }}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="text" width={200} height={28} />
      </Box>
      {Array.from({ length: rows }).map((_, i) => (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
          <Skeleton variant="rounded" width={8} height={40} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={`${50 + (i * 15) % 40}%`} height={20} />
            <Skeleton variant="text" width={`${30 + (i * 20) % 40}%`} height={16} />
          </Box>
          <Skeleton variant="rounded" width={60} height={24} />
        </Box>
      ))}
    </CardContent>
  </Card>
);

const DashboardSkeleton: React.FC = () => {
  return (
    <Box>
      {/* Title */}
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="text" width={250} height={40} />
        <Skeleton variant="text" width={150} height={20} />
      </Box>

      {/* Stat cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <StatCardSkeleton />
          </Grid>
        ))}
      </Grid>

      {/* Sections */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <SectionSkeleton rows={3} />
        </Grid>
        <Grid item xs={12} md={6}>
          <SectionSkeleton rows={3} />
        </Grid>
        <Grid item xs={12}>
          <SectionSkeleton rows={4} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardSkeleton;
